export const TEST_MODULE_CHITIET_ROUTE_PATH = '/admin/test-module-chitiet' as const
